import styled from 'styled-components'

export const ModalHeaderWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 12px;
  border-bottom: 1px solid var(--gray-200);
`

export const ModalTitle = styled.h5`
  font-size: 16px;
  font-weight: 600;
  color: var(--blue-600);
  margin: 0;
`

export const ModalBodyWrapper = styled.div`
  padding: 12px 12px 0 12px;
  background: var(--gray-white);
`

export const UploadArea = styled.div<{ isDragActive: boolean }>`
  border: 2px dashed var(--gray-300);
  background: var(--gray-white);
  border-radius: 8px;
  padding: 40px 0;
  text-align: center;
  cursor: pointer;
  transition:
    border-color 0.2s ease,
    background-color 0.2s ease;
  margin-bottom: 16px;
  box-shadow: 0 1px 2px 0 rgba(16, 24, 40, 0.05);
  ${(props) =>
    props.isDragActive &&
    `
    background: var(--blue-100);
    border-color: var(--blue-400);
  `}
`

export const UploadedFileSample = styled.div`
  display: flex;
  align-items: center;
  background: var(--gray-100);
  border-radius: 8px;
  padding: 12px 16px;
  margin-top: 16px;
  margin-bottom: 8px;
  font-size: 14px;
  color: var(--gray-700);
  justify-content: space-between;
`

export const FileName = styled.span`
  font-weight: 500;
  color: var(--blue-700);
`

export const FileSize = styled.span`
  font-size: 14px;
  color: var(--gray-400);
  margin-left: 8px;
`

export const BottomBar = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 12px;
  border-top: 1px solid var(--gray-200);
  background: var(--gray-white);
`

export const SecondaryButton = styled.button`
  min-width: 80px;
  height: 36px;
  margin-right: 8px;
  background: var(--gray-white);
  color: var(--blue-500);
  border: 1px solid var(--blue-500);
  font-weight: 500;
  font-size: 14px;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  cursor: pointer;
  &:hover:not(:disabled) {
    background: var(--blue-100);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`

export const PrimaryButton = styled.button`
  min-width: 80px;
  height: 36px;
  background: var(--blue-500);
  color: #fff;
  font-weight: 500;
  font-size: 14px;
  border: none;
  border-radius: 6px;
  transition: background-color 0.2s ease;
  cursor: pointer;
  &:hover:not(:disabled) {
    background: var(--blue-600);
  }
  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    pointer-events: none;
  }
`

export const DicomUploadIcon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;

  i {
    font-size: 80px;
    color: var(--blue-300);

    &:before {
      color: var(--blue-300);
    }
  }
`
